(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('BaseListController', BaseListController);
    

    BaseListController.$inject = [
        '$templateCache',
        'baseFlotaService',
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        'notificationService',
        '$timeout',
        'genericDataService',
        'userService',
        'simpleModalService',
        'common',
        'uiGridConstants', 
        'restrictionService'
    ];

    

    function BaseListController($templateCache,
        baseFlotaService,
        $scope,
        $rootScope,
        $state,
        $filter,
        notificationService,
        $timeout,
        genericDataService,
        userService,
        simpleModalService,
        common,
        uiGridConstants,
        restrictionService) {
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
            var templates = {
                accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
                rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
            };


        var paginationOptions = {
            pageNumber: 1,
            pageSize: 25,
            sort: null
        };
        var sorting = {
            field: null,
            direction: null
        };

        var vm = this;
        vm.restrictionService = restrictionService; 
        vm.appliedFilters = [];
        $scope.gridData = [];
        vm.genericDataService = genericDataService;
        vm.focusedRow = null;
        vm.loadingInformation = true;
        vm.rowCount = 0;
        vm.firstLoaded = false;
        vm.gridData = [];
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,
            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
            useExternalPagination: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,
            primaryKey: 'baseId',
            columnDefs: [

                {
                    field: 'id',
                    displayName: 'Id',
                    width: 70,
                    resizable: true,
                    sort: { priority: 1, direction: 'desc' }

                }, 

                {
                    name: 'nombre',
                    displayName: 'Nombre',
                    width: 230,
                    resizable: true
                },

                {
                    field: 'direccion',
                    displayName: 'Dirección',
                    resizable: true
                },

                {
                     field: 'poblacion',
                     displayName: 'Población',
                     resizable: true
                },

                {
                    field: 'provincia',
                    displayName: 'Provincia',
                    resizable: true
                },

                {
                    field: 'telefono',
                    displayName: 'Teléfono',
                    minWidth: 110,
                    resizable: true
                },

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    width: 90,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate,
                    enableSorting: false
                }

			],
			data: 'gridData',

            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll = false;
            }
		};

        vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
        vm.goToEdit = goToEdit;
        vm.deleteAllItems = deleteAllItems;
        vm.remove = remove;
        vm.focusRow = focusRow;
        vm.isFocused = isFocused;
        vm.deleteSearchData = deleteSearchData;
        vm.filterGrid = filterGrid;

        vm.clearSearcher = clearSearcher;
        vm.searchText = '';


        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('bases')];

        (function () {
   //          var state = $rootScope.stateStorage[vm.tab.name];
   //          if (state && vm.tab.keepState) {
   //              vm.focusedRow = state.focusedRow || null;
   //          }
			loadData();
		})();

        $scope.$on('detail-resize', function (event, args) {
            // if (vm.tab.isActive()) {
            //     if (!common.isNullOrUndefined(vm.gridApi))
            //         $timeout(function () { vm.gridApi.core.handleWindowResize(); }, 0);
            // }
        });

        function clearAll() {
            if (!common.isNullOrUndefined(vm.gridApi))
                vm.gridApi.selection.clearSelectedRows();
        }

		function loadData() {
            clearAll();
            vm.searchText = ''; 
            vm.loadingInformation = false;
            baseFlotaService.getList()
                .then(function (result) {
                    //vm.gridOptions.totalItems = result.data.length;
                    vm.firstLoaded = true;
                    vm.rowCount = result.data.length;
                    $scope.gridData = result.data;
                    vm.gridData = result.data;
                });

        }


        function focusRow(base) {
            vm.focusedRow = base.baseId;
        }

        function isFocused(base) {
            return vm.focusedRow === base.baseId;
        }

        function goToEdit(base) {
            restrictionService.hasPermission('modificar', 'base', 'flota.configuracion.editarBase', { 'id': base.baseId });

			//$state.go('flota.configuracion.editarBase', { 'id': base.baseId });
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }

        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }

        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }

        function filterGrid() {
            if (vm.searchText !== '') {
                $scope.gridData = $filter('searchFilter')(vm.gridData, {
                    'nombre': vm.searchText,
                    'id': vm.searchText,
                    'telefono': vm.searchText,
                }, true);
            }
            else {
                $scope.gridData = vm.gridData;
            }

            vm.gridOptions.totalItems = $scope.gridData.length;
            vm.rowCount = $scope.gridData.length;
            vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
        }

        function deleteSearchData() {
            vm.searchText = '';
            filterGrid();
        }


        function clearSearcher() {
            vm.searchText = '';
            filterGrid();
        }


        function remove(base) {
            if (!restrictionService.hasPermission('eliminar', 'base')) return; 

            notificationService.sendAppNotification({
                message: 'Dando de baja base...',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
            baseFlotaService.deleteById([base.baseId]).then(function () {
                loadData();
                notificationService.sendAppNotification({
                    message: 'Base dado de baja con éxito',
                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                });
            }, function () {
                notificationService.sendAppNotification({
                    message: 'Ha ocurrido un error al dar de baja la base',
                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
                });
            });
        }

        function deleteAllItems() {
            if (!restrictionService.hasPermission('eliminar', 'base')) return; 

            simpleModalService
                .yesNoModal('Confirmación eliminar', '¿Desea eliminar las bases seleccionadas?')
                .then(function (result) {
                    if (result) {
                        var basesIds = [];
                        var selected = vm.gridApi.selection.getSelectedRows();
                        for (var i = 0; i < selected.length; i++) {
                            basesIds.push(selected[i].baseId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Dando de baja bases...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
                        baseFlotaService.deleteById(basesIds)
                            .then(function () {
                                loadData(); 
                                notificationService.sendAppNotification({
                                    message: 'Bases dadas de baja con éxito',
                                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
                                });
                            },
                                function () {
                                    notificationService.sendAppNotification({
                                        message: 'Ha ocurrido un error al dar de baja las bases',
                                        positionY: 'top', positionX: 'right', delay: null, type: 'error'
                                    });
                                });
                    }
                });
        }

    }

})();